"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.memoize = void 0;

var tslib_1 = require("tslib");

exports.memoize = function (provider, isExpired, requiresRefresh) {
  if (isExpired === undefined) {
    // This is a static memoization; no need to incorporate refreshing
    var result_1 = provider();
    return function () {
      return result_1;
    };
  }

  var result = provider();
  var isConstant = false;
  return function () {
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
      var resolved;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (isConstant) {
              return [2
              /*return*/
              , result];
            }

            return [4
            /*yield*/
            , result];

          case 1:
            resolved = _a.sent();

            if (requiresRefresh && !requiresRefresh(resolved)) {
              isConstant = true;
              return [2
              /*return*/
              , resolved];
            }

            if (isExpired(resolved)) {
              return [2
              /*return*/
              , result = provider()];
            }

            return [2
            /*return*/
            , resolved];
        }
      });
    });
  };
};